module.exports = __webpack_public_path__ + "img/1556451869.9a8b03da.jpg";